export const STATUS_LABEL = {
  new: "Needs triage", triaging: "Triaging", self_help: "Self-help", monitoring: "Made safe — monitoring", callout: "CALL-OUT",
  handed_over: "Handed over", closed: "Closed",
};

export const STATUS_TONE = {
  new: "bg-amber-500 text-white", triaging: "bg-amber-500 text-white", self_help: "bg-sky-600 text-white", monitoring: "bg-emerald-600 text-white",
  callout: "bg-red-600 text-white", handed_over: "bg-slate-500 text-white", closed: "bg-muted text-muted-foreground",
};

export const URGENCY_LABEL = { unknown: "Undecided", urgent: "Urgent", non_urgent: "Non-urgent" };

export const CALL_OUTCOMES = [
  ["made_safe", "Made safe until the next working day"], ["resolved", "Resolved on the phone"], ["advice_given", "Advice given"],
  ["needs_callout", "Call-out needed tonight"], ["callback", "Call back arranged"], ["no_answer", "No answer"],
];

export const SOURCE_LABEL = { tenant_report: "Tenant report form", email: "Email inbox", phone: "Phone call-in", whatsapp: "WhatsApp", text: "Text message", email_forward: "Email forwarded", in_person: "In person", client_portal: "Client call / portal", other: "Manual entry" };

export const isRed = (c) => c?.status === "callout" || (c?.urgency === "urgent" && c?.status !== "closed" && c?.status !== "handed_over");

export function hms(seconds) {
  const s = Math.max(0, Math.round(seconds || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return h ? `${h}h ${String(m).padStart(2, "0")}m` : `${m}m ${String(r).padStart(2, "0")}s`;
}

export function ago(iso) {
  if (!iso) return "";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  return h < 24 ? `${h}h ${m % 60}m ago` : `${Math.floor(h / 24)}d ago`;
}

export function ukTime(iso, withDate = true) {
  if (!iso) return "—";
  const d = new Date(iso);
  const t = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" });
  return withDate ? `${d.toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short", timeZone: "Europe/London" })} ${t}` : t;
}

export const addressLine = (a) => [a?.street_address, a?.town_city, a?.postcode].filter((p) => p && p !== "TBC").join(", ");
